// GraphQL to PropTypes: To be implemented

module.exports = () => () => null;
